<template>
  <div class="list">
    <div style="margin-bottom: 8px;">
      <vm-search label="类型">
        <el-select v-model="filter.formName" placeholder="请选择" @change="getNodeList">
          <el-option v-for="item in typeList" :key="item.formID" :label="item.formText" :value="item.formName"/>
        </el-select>
      </vm-search>
      <vm-search label="节点">
        <el-select v-model="filter.nodeText" placeholder="请选择">
          <el-option v-for="item in nodeList" :key="item.approveNodeID" :label="item.descrpt" :value="item.approveNodeID"/>
        </el-select>
      </vm-search>
      <vm-search label="处理类型">
        <el-select v-model="filter.handleResult" placeholder="请选择">
          <el-option v-for="item in handleList" :key="item.value" :label="item.label" :value="item.value"/>
        </el-select>
      </vm-search>
      <div style="display: flex;flex-direction: row; height: 28px; float: right;">
        <el-input v-model="filter.filter" style="margin-bottom: 1%;" placeholder="请输入内容" clearable/>
        <div class="ad-search-btn">
          <el-button
              type="primary"
              size="mini"
              style="margin-bottom: 1%; margin-left: 5px;"
              @click="handleSearchClick">
            查询
          </el-button>
        </div>
      </div>
    </div>
    <el-table
        v-loading="status==='loading'"
        height="75vh"
        :data="tableData"
        style="width: 100%">
      <template slot="empty">
        <i v-if="status==='loading'" class="el-icon-loading" style="font-size: 18px"/>
        <el-button v-else-if="status==='error'" @click="handleSearchClick">加载失败，点击重新获取</el-button>
        <div v-else-if="status==='empty'">暂无数据</div>
      </template>
      <el-table-column
          prop="billNO"
          label="出厂编号"
          width="180"/>
      <el-table-column
          prop="customerName"
          label="客户名称"
          width="180"/>
      <el-table-column
          prop="creatorName"
          label="制单人"/>
      <el-table-column
          prop="statusName"
          label="状态"/>
      <el-table-column
          prop="handleResultText"
          label="处理结果"/>
      <el-table-column
          prop="handlerName"
          label="审核人"/>
      <el-table-column
          prop="nodeText"
          label="订单节点"/>
      <el-table-column
          prop="handleTime"
          label="处理时间"/>
    </el-table>
    <div style="margin-top: 16px; overflow: hidden; float: right;">
      <el-pagination
          background
          class="page"
          :current-page="currentPage"
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>
<script>
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "HandledList",
    components: {VmSearch},
    data() {
      return {
        handleList: [{
          value: -1,
          label: "全部",
        }, {
          value: 1,
          label: "同意",
        }, {
          value: 3,
          label: "退回",
        }, {
          value: 4,
          label: "分配",
        }, {
          value: 5,
          label: "转交",
        }],
        typeList: [],
        nodeList: [],
        filter: {
          filter: "",
          formName: "",
          nodeText: "",
          handleResult: -1,
        },
        status: "empty",
        total: 0,
        pageSize: 10,
        currentPage: 1,
        tableData: [],
      };
    },
    mounted() {
      this.getTypeList();
    },
    methods: {
      getTypeList() {
        this.$http.get("basic", "workflows/formType")
          .then(res => {
            this.typeList = res;
            if (this.typeList) {
              this.filter.formName = this.typeList[0].formName;
              this.getNodeList();
            }
          });
      },
      getNodeList() {
        let formName = "";
        if(this.filter.formName !== "RejectBill" && this.filter.formName !== "DeliveryNote") {
          if (this.filter.formName === "BusinessApplication") {
            formName = "wf" + this.filter.formName;
          } else {
            formName = "wf" + this.filter.formName + "Application";
          }
        } else {
          formName = this.filter.formName;
        }
        this.$http.get("basic", `workflows/node/${formName}`)
          .then(res => {
            this.nodeList = res;
            console.log(this.nodeList);
          });
      },
      getList(pageNum) {
        this.status = "loading";
        if (pageNum > 0) {
          this.currentPage = pageNum;
        }
        let formName = "";
        if(this.filter.formName !== "RejectBill" && this.filter.formName !== "DeliveryNote") {
          if (this.filter.formName === "BusinessApplication") {
            formName = "wf" + this.filter.formName;
          } else {
            formName = "wf" + this.filter.formName + "Application";
          }
        } else {
          formName = this.filter.formName;
        }
        let params = {
          pageSize: this.pageSize,
          pageNum: this.currentPage,
          type: formName,
          nodeText: this.filter.nodeText,
          handleResult: this.filter.handleResult,
          filter: this.filter.filter,
        };
        this.$http.get("basic", "workflows/handledPageList", params)
          .then(data => {
            this.tableData = data.records;
            this.total = data.total;
            console.log(data);
            if (this.total === 0) {
              this.status = "empty";
            } else {
              this.status = "finish";
            }
          });
      },
      handleCurrentChange(pageNum) {
        this.getList(pageNum);
      },
      handleSearchClick() {
        this.getList(1);
      },
    },
  };
</script>
<style lang="scss">
</style>
